import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { withRadius } from '@r1-frontend/ui-react/experimental/containers';
import { TSwitchableSubscriptionProps } from '@r1-frontend/ui-react/organisms/TariffSubscription/SwitchableSubscription/SwitchableSubscription';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import Desktop from './desktop.styled';
import Mobile from './mobile.styled';

export type TTvSubscriptionProps = {
    imagePath: {
        desktop: string,
        mobile: string,
    },
} & Omit<TSwitchableSubscriptionProps, 'switcherAlign' | 'type' | 'Icon'>

const TvSubscription = ({
    imagePath,
    className,
    children,
    ...props
}: TTvSubscriptionProps): JSX.Element => {
    const isDesktop = useMatchMedia(`(min-width: ${wideBreakpoints.mobile})`);

    return (
        <div className={className}>
            {isDesktop
                ? <Desktop {...props} imagePath={imagePath.desktop}>{children}</Desktop>
                : <Mobile {...props} imagePath={imagePath.mobile}>{children}</Mobile>
            }
        </div>
    );
};

export default styled(withRadius(TvSubscription, { $desktop: 32, $mobile: 24 }))`
    background-color: ${COLORS.BgSurface};
`;
